import React from "react";
import "./style/about.css";

function About() {
  return (
    <div className="about">
      <section className="cards">
        <div className="card">
          <div className="icon">
            <img src="images/fast.svg" alt="" />
          </div>
          <h3>Rapide</h3>
        </div>
        <div className="card">
          <div className="icon">
            <img src="images/easy.svg" alt="" />
          </div>
          <h3>Facile</h3>
        </div>
        <div className="card">
          <div className="icon">
            <img src="images/fast.svg" alt="" />
          </div>
          <h3>Gratuit</h3>
        </div>
      </section>

      <section className="info">
        <img src="images/question.svg" alt="" />
        <article>
          <div>
            <h4>À propos de notre Plateforme</h4>
            <p>
              Notre plate-forme fournit un calcul de score rapide et facile .
            </p>
          </div>
          <div>
            <h4>À propos de moi</h4>
            <p>
              je suis Hamza Khazri , un développeur / concepteur web de Tunisie . Contactez-moi
              pour des commentaires ou une opportunité d'emploi . j'ai réalisé ce design web avec habib fathalli <a href="https://www.instagram.com/habib_fathalli" target="_blank">cliquez ici</a> pour visiter son instagram
            </p>
          </div>
        </article>
      </section>
    </div>
  );
}

export default About;
